// extracted by mini-css-extract-plugin
module.exports = {"item":"PeopleEducation_item__Muw5I","search-fade-in":"PeopleEducation_search-fade-in__l5kKI"};